import classNames from 'classnames';

const Step = ({
  isActive,
  roundedLeft,
  roundedRight,
}: {
  isActive: boolean;
  roundedLeft: boolean;
  roundedRight: boolean;
}) => {
  return (
    <div
      className={classNames(
        'h-3 flex-1',
        isActive ? 'bg-green-4' : 'bg-grey-1',
        roundedLeft ? 'rounded-l-full' : '',
        roundedRight ? 'rounded-r-full' : ''
      )}
    ></div>
  );
};

export type StepperProps = {
  activeStep: number;
  steps: number;
};

const Stepper = ({ activeStep = 0, steps }: StepperProps) => {
  return (
    <div className="flex h-3 flex-row rounded-full">
      {Array.from({ length: steps }, (_, i) => (
        <Step key={i} isActive={i + 1 <= activeStep} roundedLeft={i === 0} roundedRight={i === steps - 1} />
      ))}
    </div>
  );
};

export default Stepper;
